export interface IDocumentDownload {
        fileData: string; // base64 encoded data
        fileName: string;
        mimeType: string;
    }

    export class DocumentDownload implements IDocumentDownload {
        fileData: string;
        fileName: string;
        mimeType: string;
    }